// extracted by mini-css-extract-plugin
module.exports = {"varselKontekstPage":"VarselIKontekstPage_varselKontekstPage__wG42V"};